/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ===== START of cookie functions =====
function setTheCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getTheCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseTheCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
// ===== END of cookie functions =====

// ===== START wishlist functions =====
function setupWishlistButtons() {
  if (
    getTheCookie("wishlist") != null &&
    getTheCookie("wishlist") != "__" &&
    getTheCookie("wishlist") != ""
  ) {
    var str = String(getTheCookie("wishlist")).split("__");
    for (var i = 0; i < str.length; i++) {
      if (str[i] != "") {
        console.log("test wishlist ", ".added-wishbutton-" + str[i]);
        document.querySelector(".added-wishbutton-" + str[i]) != null
          ? (document.querySelector(
              ".added-wishbutton-" + str[i]
            ).style.display = "block")
          : "";
        document.querySelector(".default-wishbutton-" + str[i]) != null
          ? document.querySelector(".default-wishbutton-" + str[i]).remove()
          : "";
        document.querySelector(".loadding-wishbutton-" + str[i]) != null
          ? document.querySelector(".loadding-wishbutton-" + str[i]).remove()
          : "";
      }
    }
  }
}
function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency =
    document.getElementsByTagName("html")[0].getAttribute("currency") || "$";
  return currency + price;
}
// ===== END wishlist functions =====

$(document).ready(function () {

  // ===== START wishlist js =======
  if ($(".add-in-wishlist-js").length != 0) {
    $(document).on("click", ".add-in-wishlist-js", function (event) {
      if ($(this).hasClass("added-wishlist")) return true;
      event.preventDefault();
      try {
        var id = $(this).data("wishlist");
        if (getTheCookie("wishlist") == null) {
          var str = id;
        } else {
          if (getTheCookie("wishlist").indexOf(id) == -1) {
            var str = getTheCookie("wishlist") + "__" + id;
          }
        }
        setTheCookie("wishlist", str, 14);
        $(".loadding-wishbutton-" + id).show();
        $(".default-wishbutton-" + id).remove();
        setTimeout(function () {
          $(".loadding-wishbutton-" + id).remove();
          $(".added-wishbutton-" + id).show();
        }, 2000);
      } catch (err) {
        console.log("error reading wishlist cookies!");
      }
    });
  }
  setupWishlistButtons();
  // ===== END wishlist js =======
  
  
  //livestream close event
  $(".livestreamPopup__Close").click(function () {
    $(".LivestreamPopup ").hide();
  });

  //Trigger web accessibility widget
  $(".web-accessibility").click(function () {
    // $(".Sea-Accessibility_WidgetIcon").trigger("click");
    $(".acsb-trigger").trigger("click");
  });

  //*** Start PDP desc read-more/less click event
  $(".read-more").click(function () {
    $(".pro_description").css("height", "auto");
    $(".read-less").show();
    $(".read-more").hide();
  });
  
  $(".read-less").click(function () {
    $(".pro_description").css("height", "160");
    $(".read-less").hide();
    $(".read-more").show();
  });
  
  //*** End PDP desc read-more/less click event

  // if (!(window.location.href.indexOf("gift-card") > -1)) {
  //    $(".variant-picker__option .swatch_item").click(function(){
  //       var $this = $(this);
  //        setTimeout(function () {
  //         $(".size-helper").hide();
        
  //         if($(".variant-picker__option .swatch_item input:checked").val() == "S/M") {
  //           $("#swatch-S_M").show();
  //         }
  //         if($(".variant-picker__option .swatch_item input:checked").val() == "M/L") {
  //           $("#swatch-M_L").show();
  //         }
  //         if($(this).find("input").val() == "Free Size") {
  //           $("#swatch-FreeSize").show();
  //         }
  //         $("#swatch-" + $this.find("input").val()).show();
  //         $("#swatch-" +  $this.find("input").attr("data-input-value")).show();
  //        }, 300);
  //    });
    

  //   $(".size-helper").hide();
  //   if($(".variant-picker__option .swatch_item input:checked").val() == "S/M") {
  //     $("#swatch-S_M").show();
  //   }
  //   if($(".variant-picker__option .swatch_item input:checked").val() == "M/L") {
  //     $("#swatch-M_L").show();
  //   }
  //   if($(".variant-picker__option .swatch_item input:checked").val() == "Free Size") {
  //     $("#swatch-FreeSize").show();
  //   }
  //   $("#swatch-" + $(".variant-picker__option .swatch_item input:checked").val()).show();   
  //   $("#swatch-" +  $(".variant-picker__option .swatch_item input:checked").attr("data-input-value")).show();
  // }

  //********* START code Quick view swatch click event to update size helper
  // $(document).on("click", ".modal-quickview variant-picker .swatch_item", function () {
  //   var dataModalVarVal = $(this).find("input").attr("data-input-value");
  //   var quickVariantPicker = $(this).closest("variant-picker");
  //   quickVariantPicker.find(".size-helper").hide();
  //   quickVariantPicker.find("#swatch-" +dataModalVarVal).show();
  // });
  //********* END code Quick view swatch click event to update size helper
  
  //to show open menu on mobile
  $("#sidebar-menu .Collapsible:nth-child(3)>.Collapsible__Button").trigger("click");
  
  //to make best-sellers visible on the all collections page.
  if (window.location.href.indexOf("/collections/all") > -1 && !(window.location.href.indexOf("sort_by") > -1) && window.location.href.indexOf("all-bags") === -1) {
    $("button[data-value='best-selling']").trigger("click");
  }
  
  //change breadcrumb title of collections list page
  $(".template-list-collections .PageHeader h1").html("Hotlist");

  // Footer__PaymentList append 
  var paypal = $(".default-class").find(".icon-paypal").html();
  $(".default-class").find(".Footer__PaymentList").append('<li class="icon-paypal HorizontalList__Item">' + paypal + "</li>");
  var afterpay = $(".default-class").find(".icon-afterpay").html();
  $(".default-class").find(".Footer__PaymentList").append('<li class="icon-afterpay HorizontalList__Item">' + afterpay + "</li>");

  // live page scroll top js 
  $("#live-remind-btn").click(function () {
    $("html,body").animate({
      scrollTop: $("#shopify-section-template--15538933858494__16513736609c127b2f").offset().top,
    });
  });

  // Holiday-sale-2022 scroll top js 
  if (window.location.href.indexOf("holiday-sale-2022?page=") > -1) {
    $("html, body").animate({
        scrollTop: $("#shopify-section-template--15963072364734__collection").offset().top,
      },
      2000
    );
  }

  // PDP sticky button js 
  if (window.matchMedia("(max-width: 640px)").matches) {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 1000) {
        $(".sticky-cartbtn").fadeIn(500);
      } else {
        $(".sticky-cartbtn").fadeOut(500);
      }
    });
    $(".stickyaddtocart").click(function () {
      $('.ProductForm__AddToCart[type="submit"]').trigger("click");
    });
  }
  
  // START custom-tab section Js
  $(".tab-item").click(function () {
    $(".answer-block").removeClass("active");
    $(".faq-answer").removeClass("tab-active");
    $(".faq-btn").removeClass("active");
    $("#contact_form").removeClass("active");
    $(".tab-content-block").addClass("active");
    $(".tab-item").removeClass("active-a");
    $(this).addClass("active-a");
    $(".tab-question").removeClass("tab-active");
    $(".tab-question[data-id='" + $(this).find(".tab-a").data("id") + "']").addClass("tab-active");
    $(".question_heading").show();
  });
  $(".tab-question .faq-item").click(function () {
    $(".answer-block").addClass("active");
    $(".tab-question .faq-item").removeClass("active");
    $(this).addClass("active");
    $(".faq-answer").removeClass("tab-active");
    $(".answer-info-block[data-id='" + $(this).parents(".tab-question").data("id") + "'] .faq-answer[data-id='" + $(this).find(".question").data("id") + "']").addClass("tab-active");
    $(".faq-btn").addClass("active");
  });
  $(".faq-btn .btn").click(function () {
    $(".faq-btn .btn").removeClass("active");
    $(this).addClass("active");
  });
  $(".faq-btn .contact_btn").click(function () {
    $("#contact_form").addClass("active");
  });
  $(".faq-btn .yes_btn").click(function () {
    $("#contact_form").removeClass("active");
  });
  $(".tab-question .faq-item").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".tab-answer-block").offset().top - 120,
      },
      2000
    );
  });
  if (window.matchMedia("(max-width: 543px)").matches) {
    $(".tab-item").click(function () {
      $("html, body").animate(
        {
          scrollTop: $(".tab-question.tab-active").offset().top - 120,
        },
        2000
      );
    });
  }
  // END custom-tab section Js
  
  // START More filter click event 
  $(document).on("click", ".more-filter .open", function () {
    $(this).css("display", "none");
    $(this).closest(".more-filter").find(".close").css("display", "block");
    $(this).closest(".Collapsible__Content").find(".v-stack").css("overflow-y", "scroll");
    $(this).closest(".Collapsible__Content").find(".h-stack").css("overflow-y", "scroll");
  });
  
  $(document).on("click", ".more-filter .close", function () {
    $(this).css("display", "none");
    $(this).closest(".more-filter").find(".open").css("display", "block");
    $(this).closest(".Collapsible__Content").find(".v-stack").css("max-height", "285px");
    $(this).closest(".Collapsible__Content").find(".h-stack").css("max-height", "285px");
    $(this).closest(".Collapsible__Content").find(".more-filter").css("width", "70px");
    $(this).closest(".Collapsible__Content").find(".v-stack").css("overflow-y", "hidden");
    $(this).closest(".Collapsible__Content").find(".h-stack").css("overflow-y", "hidden");
  });
  // END More filter click event

  // ==== START sticky header js ==========
$(function () {
  const $win = $(window), $header = $('#section-header');
  let isSmall = false, timer;

  const ADD_AT = Math.max(60, $header.outerHeight() * 0.6);
  const REMOVE_AT = 4, REMOVE_DELAY = 120;

  $win.on('scroll', () => {
    const y = $win.scrollTop();

    if (y > ADD_AT && !isSmall) {
      clearTimeout(timer);
      $header.addClass('small_header');
      isSmall = true;
    } 
    else if (y <= REMOVE_AT && isSmall) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if ($win.scrollTop() <= REMOVE_AT) {
          $header.removeClass('small_header');
          isSmall = false;
        }
      }, REMOVE_DELAY);
    }
  });
});
  // ======= END sticky header js ======= 

  // ======= START PDP pop-up js  ====== 
  jQuery(document).on("tdf_render", function () {
    var $m = jQuery("#tdf_upsell .tdf_offer_message");
    setTimeout(function () {
      if ($m.length) {
        var $p = $m.find(".progress");
        if (!$p.length) {
          $m.prepend('<div class="progress"></div>');
          var clonedDiv = $(".shipping_amount_html").clone();
          $("#tdf_upsell .progress").append(clonedDiv);
          $p = $m.find(".progress");
        }
        $p.html(jQuery("the progress bar of cart drawer").html());
      }
    }, 1500);
  });
  // ======= END PDP pop-up js  ======

  
  // ======= START klaviyo notify me button code ======
    var interval = setInterval(function () {
      if ($(".klaviyo-bis-trigger")) {
        $(".klaviyo-bis-trigger").insertBefore(
          ".product-info__block-list > .product-info__block-item > .shopify-product-form"
        );
    
        $(".buyitnow_btn.klaviyo-bis-trigger").is(":visible")
          ? $(".btninstant").hide()
          : $(".btninstant").show();
        clearInterval(interval);
      }
    }, 1000);
    
    $(document).on("click", ".swatch_item", function () {
      setTimeout(function () {
        $(".buyitnow_btn.klaviyo-bis-trigger").is(":visible")
          ? $(".btninstant").hide()
          : $(".btninstant").show();
      }, 500);
    });
  // ======= END klaviyo notify me button code  ======

  // ======= START Handle click on suggested keyword in search bar ======
  $(document).on("click", ".recently_arti span", function (event) {
    var textToAdd = $(this).text();
    $(".header-search__input").val(textToAdd);
    var searchinputValue = textToAdd.trim().replace(/ /g, "+");
    var searchLink = `https://www.americaandbeyond.com/search?section_id=predictive-search&q=${searchinputValue}&options[prefix]=last&type=product`;

    $.ajax({
      url: searchLink,
      type: "GET",
      success: function (data) {
        // Clear the previous content to avoid duplicates
        $(".predictive-search__content")
          .empty()
          .html(data)
          .css("display", "block");
        var inputValue = $(".header-search__input").val();
        if (inputValue.length !== 0) {
          $(".custom_search").addClass("custom_box_enable");
          $(".predictive-search__content").css("display", "block");
        } else {
          $(".custom_search").removeClass("custom_box_enable");
          $(".predictive-search__content").css("display", "none");
        }
      },
      error: function (error) {
        // Log an error message if the AJAX request fails
        console.error("Error fetching product information:", error);
      },
    });
  });
  
  // Also handle clicks on SVGs inside the span
  $(document).on("click", ".recently_arti span svg", function (event) {
    // Prevent the event from propagating to avoid double handling
    event.stopPropagation();

    // Trigger the click event on the parent span
    $(this).closest("span").hide();
  });
  // ======= END Handle click on suggested keyword in search bar ======
  
  // ======= START Cart Drawer upsell ======

  //upsell ajax cart click event
  $(document).on("click", ".upsell-product-btn", function () {
    var $btn = $(this);
    var ajaxVariantID = $(this).attr("data-variant-id");
    $btn.addClass("ajax-loader");
    upsellAddToCartJS(1, ajaxVariantID, $btn);
  });

  //Function to add upsell product to cart via AJAX
  function upsellAddToCartJS(ajax_quantity, ajaxVariantId, $btn) {
    data = {
      id: ajaxVariantId,
      quantity: ajax_quantity,
      properties: {
          "Upsell Item": "1",
        },
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        $btn.removeClass("ajax-loader");
      },
    });
  }
 // ======= END Cart Drawer upsell ======

  // ======= START Show predictive search box when typing in search input ======
  $(".header-search__input").on("input", function () {
    var inputValue = $(this).val();
    if (inputValue.length !== 0) {
      $(".custom_search").addClass("custom_box_enable");
    } else {
      $(".custom_search").removeClass("custom_box_enable");
    }
  });
  // ======= END Show predictive search box when typing in search input ======

 // ======= START buy button click event ======
  $(document).on("click", ".buy-btn.btninstant", function (event) {
    var buyItNow = document.querySelector(".buy-btn.btninstant");
    var variantID = document.querySelector('[name="id"]').value;
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        buyItNow.classList.add("loading");
        window.location = "/checkout";
      }
    };
    var data = JSON.stringify({ quantity: 1, id: variantID });
    xhr.send(data);
  });
 // ======= END buy button click event ======

  
  // ======= START PDP Fetch similar products using Shopify recommendations API. ======
  var product_id = $(".view_similars").data("id");
  fetch(
    window.Shopify.routes.root +
      `recommendations/products.json?product_id=${product_id}&limit=8&intent=related`
  )
    .then((response) => response.json())
    .then(({ products }) => {
      $.each(products, function (i, product) {
        var product_url = `${location.origin}/products/${product.handle}?view=Product_recommendations`;
        $.ajax({
          url: product_url,
          type: "GET",
          success: function (data) {
            // $(".similar_all_product").empty();
            $(data).appendTo(".similar_all_product");
          },
          error: function (error) {
            // Log an error message if the AJAX request fails
            console.error("Error fetching product information:", error);
          },
        });
      });
    });
  // ======= END PDP Fetch similar products using Shopify recommendations API. ======

  // ======= START influencers section arrow click event ======= 
  $(document).on("click", ".btn_aero_right", function () {
    // Scroll the influencers block to the right by 450px
    $(".influencers-block").animate({ scrollLeft: "+=450px" }, 500);
  });

  $(document).on("click", ".btn_aero_left", function () {
    // Scroll the influencers block to the left by 450px
    $(".influencers-block").animate({ scrollLeft: "-=450px" }, 500);
  });
  
  $(document).on("click", ".aero_right_button_slider", function () {
    // Scroll the social proof video section to the right by 450px
    $(".socialproof-video").animate({ scrollLeft: "+=450px" }, 500);
  });
  
  $(document).on("click", ".aero_left_button_slider", function () {
    // Scroll the social proof video section to the left by 450px
    $(".socialproof-video").animate({ scrollLeft: "-=450px" }, 500);
  });
  // ======= END influencers section arrow click event ======= 

  // ======= START if the current URL contains "pages/brand-ambassador" =======
  if (window.location.href.indexOf("pages/brand-ambassador") !== -1) {
    var isClicked = false;

    // Set up an interval to check and perform the action
    var interval = setInterval(function () {
      if (!isClicked) {
        // Simulate a click on the input with aria-label "No"
        $('input[aria-label="No"]').click();

        // Mark as clicked and clear the interval
        isClicked = true;
        clearInterval(interval);
      }
    }, 500);
  }
  // ======= END if the current URL contains "pages/brand-ambassador" =======
  
  // ======= START Add Gift Box to Cart Functionality  ======= 
  $(document).on("click", ".add-gift", function () {
    var $this = $(this);
    var variantID = 43374106312894;
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        if (window.location.href.indexOf("cart") > -1) {
          location.reload();
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      }
    };
    $this.text("Added Gift Box");
    $this.parent().find(".giftboxbutton").addClass("hidden");
    var giftFor = $this.parent().find("input[name=GiftFor]").val();
    var data = JSON.stringify({
      quantity: 1,
      id: variantID,
      properties: { "Gift Box For": giftFor },
    });
    xhr.send(data);
  });
  // ======= END Add Gift Box to Cart Functionality ======= 

 // ===== START: Remove Gift Box item based on matching "Gift Box For" value =====
  $(document).on("click", ".remove_item", function (event) {
    event.preventDefault();
    var $this = $(this);
    var removeItem = $this.data("removeitem");

    $.getJSON("/cart.js?get_cart", function (cart) {
      cart.items.filter((item) => {
        let item_properties = item.properties;
        console.log("item_properties ===== ", item_properties["Gift Box For"]);

        if (item_properties["Gift Box For"] == removeItem) {
          const variantID = $(
            `.line-item[data-giftboxfor="${item_properties["Gift Box For"]}"]`
          ).attr("data-giftboxId");

          console.log(
            "item:: ",
            $(
              '.line-item[data-giftboxfor="' +
                item_properties["Gift Box For"] +
                '"]'
            )
          );
          console.log("Gift item key:: ", variantID);

          let formData = {
            id: variantID,
            quantity: 0,
          };

          // console.log("formData:; ", formData);

          fetch(window.Shopify.routes.root + "cart/change.js?remove_gift_key", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((response) => {
              console.log("response:: ", response);

              if (window.themeVariables.settings.pageType === "cart") {
                window.location.href = "/cart";
              } else {
                // Dispatch a custom event to refresh the cart
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", { bubbles: true })
                );
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      });
    });
  });
  // ===== END: Remove Gift Box item based on matching "Gift Box For" value =====
  
  // ===== START: PDP loox Review Scroll event
  $(document).on("click", ".product-info .loox-rating", function () {
    let interval = setInterval(function () {
      if ($("#looxReviews").length > 0) {
        let headerHeight = $(".small_header").outerHeight() || 123;
        $("html, body").animate(
          {
            scrollTop: $("#looxReviews").offset().top - headerHeight,
          },
          800
        );
        clearInterval(interval);
      }
    }, 100);
  });
  // ===== END: PDP loox Review Scroll event
});
  // var interval = setInterval(function () {
  //   if (document.querySelector("#tdf_sale_widget")) {
  //    ($(".product-info__block-list .price-list").hide(),
  //     clearInterval(interval));
  //   }
  // }, 500);

document.addEventListener("DOMContentLoaded", function () {
  // ======= START cart drawer gift product add ======
  var checkInterval = setInterval(function () {
    if ($(".click_gift").length > 0) {
      $(document).on("click", ".click_gift", function () {
        if ($(this).is(":checked")) {
          var variantID = 44690321801406;
          var xhr = new XMLHttpRequest();
          var url = "/cart/add.js";
          xhr.open("POST", url, true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              if (window.location.href.indexOf("cart") > -1) {
                location.reload();
              }
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                  bubbles: true,
                })
              );
            }
          };
          var data = JSON.stringify({ quantity: 1, id: variantID });
          xhr.send(data);
        } else {
          var variantID = "44690321801406";
          var xhr = new XMLHttpRequest();
          var url = "/cart/change.js";
          xhr.open("POST", url, true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              if (window.location.href.indexOf("cart") > -1) {
                location.reload();
              }
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                  bubbles: true,
                })
              );
            }
          };
          var data = JSON.stringify({ quantity: 0, id: variantID });
          xhr.send(data);
        }
      });
      clearInterval(checkInterval);
    }
  }, 3000);

  // ======= END cart drawer gift product add ======

  // ************************* Collection Product image slider js Mobile View Start *********************************** //
(function () {
  var slickInitializedClass = 'slick-initialized-543';

  function initializeSlickIfNeeded() {
    $('.main-product-list').each(function () {
      var $slider = $(this).find('.main-collection-slider');
      var isMobile = window.matchMedia('(max-width: 543px)').matches;

      if (isMobile) {
        if (!$slider.hasClass(slickInitializedClass)) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: false,
            adaptiveHeight: false,
            dots: false,
            infinite: false,
            prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-arrow-left  icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-arrow-right  icon--direction-aware" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path></svg></button>',
          });
          $slider.addClass(slickInitializedClass);
        }
      } else {
        if ($slider.hasClass(slickInitializedClass)) {
          $slider.slick('unslick');
          $slider.removeClass(slickInitializedClass);
        }
      }
    });
  }

  // Expose to global window object
  window.initializeSlickSliders = initializeSlickIfNeeded;

  // Initial call
  initializeSlickIfNeeded();

  // Call on resize
  $(window).on('resize', initializeSlickIfNeeded);

  // Call on orientation change
  window.addEventListener('orientationchange', initializeSlickIfNeeded);
})();

// ************************* Collection Product image slider js Mobile View  End *********************************** //

 // ======= Start END collection page load more js ======

  window.loadMoreProducts = function() {
  const loadMoreBtn = document.querySelector(".load-more-class2"),
    loadMoreBtn_html = document.querySelector("#load-more-container2"),
    load = document.querySelector(".loader_class"),
    productGrid = document.querySelector(".collection .product-list");

  if (!productGrid) return;

  const currentPage = parseInt(productGrid.getAttribute("data-current-page"), 10),
    totalPages = parseInt(productGrid.getAttribute("data-total-pages"), 10);

  if (currentPage < totalPages) {
    loadMoreBtn.style.display = "none";
    load.style.display = "block";

    const nextPage = currentPage + 1;
    const nextPageUrl = `${
      window.location.href.includes("?")
        ? window.location.href + "&page="
        : window.location.href + "?page="
    }${nextPage}`;

    fetch(nextPageUrl)
      .then((res) => res.text())
      .then((html) => {
        const newProducts = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".collection .product-list").children;

        productGrid.setAttribute("data-current-page", nextPage.toString());

        for (const item of newProducts) {
          productGrid.appendChild(item.cloneNode(true));
        }

        // Reinitialize sliders or any other JS that needs to apply on new items
        if (typeof window.initializeSlickSliders === "function") {
          window.initializeSlickSliders();
        }

        load.style.display = "none";
        if (nextPage === totalPages) {
          loadMoreBtn.style.display = "none";
          loadMoreBtn_html.style.display = "none";
        } else {
          loadMoreBtn.style.display = "block";
        }
      })
      .catch((err) => {
        console.error("Error fetching new products:", err);
      });
    }
  }
  // Click event listener
  // loadMoreProducts();
  $(document).on("click", ".load-more-class2", function () {
    window.loadMoreProducts();
  });
  
  // ======= END collection page load more js ======
  
  // ======= START PDP view similar popup click event ======
  var popup = document.getElementById("popup");
  if (!popup) {
    return;
  }

  var popupcontent = popup.querySelector(".popup-content");
  var span = document.getElementsByClassName("close")[0];
  var viewSimilarsButton = document.getElementsByClassName("view_similars")[0];
  var closeButton = document.querySelector(
    ".product-gallery .popup-content .close"
  );

  viewSimilarsButton.onclick = function () {
    popupcontent.classList.add("active");
    popup.classList.add("activepop");
    popupcontent.classList.remove("closepop");
  };
  closeButton.onclick = function () {
    popupcontent.classList.remove("active");
    popup.classList.remove("activepop");
    popupcontent.classList.add("closepop");
  };
  span.onclick = function () {
    popupcontent.classList.remove("active");
    popup.classList.remove("activepop");
    popupcontent.classList.add("closepop");
  };

  window.onclick = function (event) {
    if (event.target === popup) {
      popupcontent.classList.remove("active");
      popup.classList.remove("activepop");
      popupcontent.classList.add("closepop");
    }
  };
 // ======= END PDP view similar popup click event ======

  
    // ======= START Show/hide mobile sticky cart button based on scroll position ======
    if (window.matchMedia("(max-width: 767px)").matches) {
      function isVisible($el) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elTop = $el.offset().top;
        let elBottom = elTop + $el.height();
         return((elBottom <= docViewBottom) && (elTop >= docViewTop));
      }
    }
  
    var addtocartbtn = document.querySelector(".btn-new-addtocart ");
    var findCartBTn = document.querySelector(".btninstant");
    if (addtocartbtn) {
      addtocartbtn.onclick = function () {
        $(".buy-buttons button").trigger("click");
      };
    }
    
      var stickyCart = document.getElementsByClassName("mobile-add-tocart")[0];
    if (!stickyCart) {
      return;
    }
  
    var isVisible = function (element) {
      if (!element) return false; // Check if the element exists
      var rect = element.getBoundingClientRect();
      return rect.top >= 0 && rect.bottom <= window.innerHeight;
    };
    
    var onScroll = () => {
      if (findCartBTn && isVisible(findCartBTn)) {
        // Ensure the element exists
        stickyCart.style.display = "none";
      } else {
        stickyCart.style.display = "block";
      }
    };
  
    window.addEventListener("scroll", onScroll);
   // ======= END Show/hide mobile sticky cart button based on scroll position ======

  // ======= START PDP images slider ======= 
  var slidesContainer = document.getElementsByClassName("product-gallery__thumbnail-scroller")[0]; // Access the first element
  var slide = document.querySelector(".product-gallery__thumbnail");
  var prevButton = document.getElementsByClassName("c_btn_left")[0]; // Access the first element
  var nextButton = document.getElementsByClassName("c_btn_right")[0]; // Access the first element
  if (nextButton && prevButton && slide) {
    nextButton.addEventListener("click", () => {
      var slideWidth = slide.clientWidth;
      slidesContainer.scrollLeft += slideWidth;
    });
  
    prevButton.addEventListener("click", () => {
      var slideWidth = slide.clientWidth;
      slidesContainer.scrollLeft -= slideWidth;
    });
  }
  // ======= END PDP images slider ======= 
});

// for quickview
$(document).on("keyup", ".main-pop-up-box .stepsinput", function () {
  var inputText = $(this).val(); // Get the text entered in the input
  if (inputText) {
    // If there is text, set it in the span
    $(this).closest(".personalize_modal").find(".stepsspan").text(inputText);
    $(this).closest(".personalize_modal").find(".personalisation_cart").attr("personalize-text", inputText);
    $(".previewspan").css("display", "block");
    $(".spnclassic").css("border-bottom", "1px solid #ddd");
    $(".personalisation_cart,.per_addtocart .btn-new-addtocart ").css({
      "pointer-events": "auto",
      opacity: "1",
    });
  } else {
    // If input is cleared, clear the span as well
    $(this).closest(".personalize_modal").find(".stepsspan").text("");
    $(".previewspan").css("display", "none");
    $(".spnclassic").css("border-bottom", "0px solid #ddd");
    $(".personalisation_cart,.per_addtocart .btn-new-addtocart ").css({
      "pointer-events": "none",
      opacity: "0.6",
    });
  }
});

$(document).on("click", ".scroll_to_top", function (e) {
  e.preventDefault();

  // Find the closest modal to the clicked button
  const parentModal = $(this).closest(".main-pop-up-box");

  if (parentModal.length > 0) {
    // Find the target element within the modal
    const scrollToElement = parentModal.find(".main-image-text-personalize");

    if (scrollToElement.length > 0) {
      // Animate scroll within the modal to the target element
      parentModal.animate(
        {
          scrollTop: scrollToElement.offset().top,
        },
        "slow"
      );
    }
  }
});

// personalize text scroll top js Start

$(document).on("click", ".scroll_top_personalize", function (e) {
  e.preventDefault();

  const target = $(".product-gallery__image-list .main-image-text-personalize");

  if (target.length > 0) {
    $("html, body").animate(
      {
        scrollTop: target.offset().top,
      },
      "slow"
    );
  }
});

// personalize text scroll top js End


// personalize pop-up start
// for quickview add to cart
$(document).on("click", ".product-ajax-cart-btn", function (e) {
  // e.preventDefault();
  const ajaxVariantId = $(this).attr("ajax-product-variant-id");
  // const second_varint = parentBox.find('.main-pop-up-box .modalspecial .close');
  const ajax_quantity = $(this)
    .closest(".right_container_pop_up")
    .find(".quantity-selector__input")
    .val();
  const quickPreOrder = $(this).attr("data-preorder");
  let properties = {};
  if (quickPreOrder === "true") {
    properties["Preorder Item"] = "Not eligible for returns, only exchanges.";
  }
  addToCartJS(ajaxVariantId, ajax_quantity, properties);
});

function addToCartJS(ajaxVariantId, ajax_quantity, properties = {}) {
  data = {
    id: ajaxVariantId,
    quantity: ajax_quantity,
    properties: properties,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      document
        .querySelector('.tdf_cart_icon[aria-controls="cart-drawer"]')
        .click();
      setTimeout(function () {
        // $(".modal.giftwrapmodal::part(close-button)").trigger("click");
      }, 2000);
    },
  });
}

// personalize product ajax old code Start

// $(document).on(
//   "click",
//   ".quick-view-varaint-wrapper .block-swatch",
//   function () {
//     var cloesestElement = $(this).closest(".variant-picker__option");
//     cloesestElement
//       .find(".block-swatch.label-is-active")
//       .removeClass("label-is-active");
//     $(this).addClass("label-is-active");
//     // Get the `shop-data-variant_id` attribute value from the clicked `.block-swatch`
//     var variantPrice = $(this).attr("data-variant-price");
//     var salePrice;
//     var tdf_sale_price;
//     var cloesestMainPopElement = $(this).closest(".main-pop-up-box");
//     var tdfPriceLength = cloesestMainPopElement.find(".tdf_money");
//     setTimeout(function () {
//       tdf_sale_price = cloesestMainPopElement.find(".tdf_price_sales .tdf_money.tdf_mn").length;

//       if (tdf_sale_price > 0) {
//         salePrice = cloesestMainPopElement
//           .find(".tdf_price_sales .tdf_money.tdf_mn")
//           .text();
//         cloesestMainPopElement.find(".addtocart-price-show").text(salePrice);
//       } else {
//         salePrice = cloesestMainPopElement.find("sale-price .money, .sp_price").text();
//         cloesestMainPopElement.find(".addtocart-price-show").text(salePrice);
//       }
//     }, 1000);
//     if(tdfPriceLength > 0){
//       $(this).closest(".main_right_container_pop_up").find(".price-list ").html('<span class="sp_price">' + variantPrice + "</span>");
//     }else{
//       $(this).closest(".main_right_container_pop_up").find(".price-list ").html('<span class="money">' + variantPrice + "</span>");
//     }

//     var variantId = $(this).attr("data-variant-id");
//     $(this)
//       .closest(".main_right_container_pop_up")
//       .find(".product-ajax-cart-btn")
//       .attr("ajax-product-variant-id", variantId);
//     var variantId = $(this).attr("data-variant-id");
//     $(this)
//       .closest(".main_right_container_pop_up")
//       .find(".add-to-bag.personalisation_cart")
//       .attr("ajax-product-variant-id", variantId);
//   }
// );

// personalize product ajax old code end

$(document).on(
  "click",
  ".quick-view-varaint-wrapper .block-swatch",
  function () {
    var cloesestElement = $(this).closest(".variant-picker__option");
    cloesestElement
      .find(".block-swatch.label-is-active")
      .removeClass("label-is-active");
    $(this).addClass("label-is-active");
    // Get the `shop-data-variant_id` attribute value from the clicked `.block-swatch`
    var variantPrice = $(this).attr("data-variant-price");
    var salePrice;
    var tdf_sale_price;
    var cloesestMainPopElement = $(this).closest(".right_container_pop_up");
    setTimeout(function () {
      tdf_sale_price = cloesestMainPopElement.find(
        ".tdf_price_sales .tdf_money.tdf_mn"
      ).length;

      if (tdf_sale_price > 0) {
        salePrice = cloesestMainPopElement
          .find(".tdf_price_sales .tdf_money.tdf_mn")
          .text();
        cloesestMainPopElement.find(".addtocart-price-show").text(salePrice);
      } else {
        salePrice = cloesestMainPopElement
          .find("sale-price .money, .sp_price")
          .text();
        cloesestMainPopElement.find(".addtocart-price-show").text(salePrice);
      }
    }, 1000);
    $(this)
      .closest(".main_right_container_pop_up")
      .find(".price-list ")
      .html('<span class="sp_price">' + variantPrice + "</span>");
    var variantId = $(this).attr("data-variant-id");
    $(this)
      .closest(".main_right_container_pop_up")
      .find(".product-ajax-cart-btn")
      .attr("ajax-product-variant-id", variantId);
    var variantId = $(this).attr("data-variant-id");
    $(this)
      .closest(".main_right_container_pop_up")
      .find(".add-to-bag.personalisation_cart")
      .attr("ajax-product-variant-id", variantId);
  }
);

// personalize product ajax

$(document).on(
  "click",
  ".right_container_pop_up .add-to-bag.personalisation_cart",
  function (e) {
    // e.preventDefault();
    const ajaxVariantId = $(this).attr("ajax-product-variant-id");
    const parent_personalize = $(this).closest(".modalspecial");
    const parent_first_varint = $(this).closest(".main_right_container_pop_up");
    const addto_card_personalizer = parent_personalize.find(
      ".modal-content .close"
    );
    // const first_varint = parent_first_varint.find('.variant-picker__option-values .swatch_item:nth-child(1) .block-swatch');
    // first_varint.trigger('click');
    addto_card_personalizer.trigger("click");
    var personalisation_Cart = "";
    if ($(this).attr("personalize-text") != "") {
      personalisation_Cart = $(this).attr("personalize-text");
    } else {
      personalisation_Cart = "";
    }
    const ajax_quantity = $(this)
      .closest(".right_container_pop_up")
      .find(".quantity-selector__input")
      .val();
    addToCartJSper(ajaxVariantId, ajax_quantity, personalisation_Cart);
  }
);
function addToCartJSper(ajaxVariantId, ajax_quantity, personalisation_Cart) {
  data = {
    id: ajaxVariantId,
    quantity: ajax_quantity,
    properties: {
      Text: personalisation_Cart,
    },
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      document
        .querySelector('.tdf_cart_icon[aria-controls="cart-drawer"]')
        .click();
      setTimeout(function () {
        // $(".modal.giftwrapmodal::part(close-button)").trigger("click");
      }, 2000);
    },
  });
}
// Personalize product quickview code Start ======================================


// $(document).on("click", ".main-pop-up-box .btnspecial_product", function () {
//   // Find the closest parent .main-pop-up-box
//   const parentBox = $(this).closest(".main-pop-up-box");
//   // Find the modal within the same .main-pop-up-box
//   const modal = parentBox.find(".modalspecial");
//   const addto_card = parentBox.find(".quickview-product-popup-button");
//   const personalize_btn = parentBox.find(".main-specialbtn");
//   const second_varint = parentBox.find(
//     ".variant-picker__option-values .swatch_item:nth-child(2) .block-swatch"
//   );
//   // Display the modal
//   if (modal.length) {
//     modal.css("display", "block");
//     addto_card.css("display", "none");
//     personalize_btn.css("display", "none");
//     // for main image change
//     $(
//       ".left_container_pop_up .personalize_image_span,.product-gallery .page-dots,.personalize_all"
//     ).css("display", "block");
//     // $(".variant-picker__option-values .swatch_item:nth-child(2) .block-swatch").trigger("click");
//     second_varint.trigger("click");
//     // $('.mobile-none-view').css('display', 'block').addClass('activeview');
//     $(".main-pop-up-box .page-dots").css("display", "none");
//     $(
//       ".product-gallery__image-list .contents,.product-gallery__thumbnail-list,.product-gallery .page-dots,.left_container_pop_up .custom_scroll_cls"
//     ).css("display", "none");
//   }
// });


$(".personalize_modal").each(function () {
    const parentBox = $(this);
    const modal = parentBox.find(".modalspecial");

    if (modal.length > 0 && modal.is(":hidden")) {
      const personalize_btn = parentBox.find(".main-specialbtn");

      // Show personalized image elements
      $(".left_container_pop_up .personalize_image_span").show();

      // Hide default elements
      $(".personalize_modal .product-gallery__thumbnail-list, .personalize_modal .page-dots,.personalize_modal .left_container_pop_up .custom_scroll_cls").hide();
    }
});

// Personalize product quickview code End ======================================

// on variant change estimation text show hide js Start =================

$(document).on('change', '.product-variant-picker .swatch_item input', function () {
 
  setTimeout(function () {
    var selectedVariantId = $('product-form .product-selected-variant-input').val();
  
    // var isMatched = false;
    // Hide all variant estimations by default
    $('.metafield-estimation-text .variant_matching').hide();
    var selectedVariantMeta = $('.variant_matching[data-variants-id="' + selectedVariantId + '"]');
    var estimationMetafieldValue  = selectedVariantMeta.attr("data-estimation-metafield");
    if (selectedVariantMeta.length > 0 && estimationMetafieldValue  !== undefined && estimationMetafieldValue .trim() !== "") {
      selectedVariantMeta.show();
      $('.product-estimation_text .default-estimation-text').hide();
    } else {
      $('.product-estimation_text .default-estimation-text').show();
    }
  }, 0);
});
// quickview on variant change estimation text show hide js Start =================

$(document).on('click', '.main-pop-up-box .quick-view-varaint-wrapper .swatch_item label', function () {
  var selectedVariantId = $(this).attr('data-variant-id');
  var selectedclosest = $(this).closest('.main-pop-up-box');
  
  // Hide all variant estimations
  $('.metafield-estimation-text .variant_matching').hide();
  selectedclosest.find('.metafield-estimation-text svg').hide();

  // Try to find the matching one
  var $matched = selectedclosest.find('.variant_matching[data-variants-id="' + selectedVariantId + '"]');
  var estimationText = $matched.attr('data-estimation-metafield');

  if ($matched.length && estimationText && estimationText.trim() !== '') {
    // Show matched variant text
    $matched.show();
    selectedclosest.find('.product-estimation_text .default-estimation-text').hide();
    selectedclosest.find('.product-estimation_text .metafield-estimation-text svg').show();
    
  } else {
    // Fallback
    selectedclosest.find('.product-estimation_text .default-estimation-text').show();
  }
});
//quickview  on variant change estimation text show hide js End =================


// Close functionality for the quickview personalize text remove Start

$(document).on("click", ".buttongiftbox .giftboxbutton", function () {
   setTimeout(() => {
    const modal = $(".personalize_modal");
    if (!modal.length) return;

    const stepspan = modal.find(".stepsspan");
    const stepsinput = modal.find(".stepsinput");
    const personalizeCart = modal.find(".personalisation_cart");

    if (stepspan.text().trim() || stepsinput.val().trim() || personalizeCart.attr("personalize-text")) {
      stepspan.text("");
      stepsinput.val("");
      personalizeCart.attr("personalize-text", "");
    }
  }, 100);
});

// Close functionality for the quickview personalize text remove End 


// Close functionality for the modal
$(document).on("click", ".main-pop-up-box .modalspecial .close", function () {
  const parentBox = $(this).closest(".main-pop-up-box");
  const modal = $(this).closest(".modalspecial");
  const addto_card = parentBox.find(".quickview-product-popup-button");
  const personalize_btn = parentBox.find(".main-specialbtn");
  const first_varint = parentBox.find(
    ".variant-picker__option-values .swatch_item:nth-child(1) .block-swatch"
  );
  // Hide the modal
  if (modal.length) {
    modal.css("display", "none");
    addto_card.css("display", "block");
    personalize_btn.css("display", "block");
    $(".left_container_pop_up .personalize_image_span").css("display", "none");
    if (window.matchMedia("(max-width: 999px)").matches) {
      $(".main-pop-up-box .page-dots").css("display", "flex");
    }
    $(
      ".product-gallery__image-list .contents,.product-gallery__thumbnail-list,.left_container_pop_up"
    ).css("display", "block");
    $(".left_container_pop_up .custom_scroll_cls").css("display", "flex");
    first_varint.trigger("click");
    $(".personalize_modal .stepsspan").text("");
    $(".personalize_modal .stepsinput").val("");
  }
});

// personalize pop-up  end

document.querySelectorAll(".scroll_to_top").forEach(function (button) {
  button.addEventListener("click", function () {
    console.log("Click the bottom:::::::::::::::");

    // Locate the modal with the correct classes for the specific button clicked
    const modal = button.closest(".modal.giftwrapmodal.modal-quickview");

    // Ensure the modal exists before accessing its shadow DOM
    if (modal) {
      // Access the part="content" element inside the modal's shadow DOM
      const content = modal.shadowRoot.querySelector('[part="content"]');

      // Scroll to the top with smooth behavior if the content element exists
      if (content) {
        content.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        console.log("Content part not found!");
      }
    } else {
      console.log("Modal not found!");
    }
  });
});

// $(document).ready(function () {
//   function adjustFooterBlocks() {
//     if ($(window).width() > 1007) {

//       // $('.footer__block.footer__block--links').eq(2).addClass('footer-location-menu');
//       // $('.footer__block.footer__block--links').first()
//       //   .append($('.footer__block.footer__block--links').eq(1));
//     } else {
//       // Move it back to its original position and remove the extra class if needed
//       // $('.footer__block.footer__block--links').eq(1).removeClass('footer-location-menu');
//       // $('.footer__block.footer__block--links').first().after($('.footer__block.footer__block--links').eq(1));
//     }
//   }

//   // Run on page load
//   adjustFooterBlocks();

//   // Run on window resize
//   $(window).resize(function () {
//     // adjustFooterBlocks();
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // Footer Location Column Append Start
  var locationMenu = document.querySelector(".footer-location-menu");
  var appendBlock = document.querySelector(".footer-append-block");

  if (locationMenu && appendBlock) {
    appendBlock.appendChild(locationMenu);
  }
  // Footer Location Column Append End

  //******* START Pre order code *********//
    // if (!$('body').hasClass('giftcard-temp')) {
  document
    .querySelectorAll(".variant-picker__option .block-swatch.variant-swatch-event")
    .forEach((label) => {
      label.addEventListener("click", function () {
        let addtocartbtn = document.querySelector(".buy-buttons button");
        let stickycartbtn = document.querySelector(".btn-new-addtocart span");
        let variantinput = document.querySelector(
          ".product-selected-variant-input"
        );
        let buttonFullDiv = document.querySelector(".tdf-ov-atc-fl");
        let preorderinputHTML = `<input class="pre-order-input" type="hidden" name="properties[Preorder Item]" value="Not eligible for returns, only exchanges.">`;
        let modalQuickView = label.closest(".modal-quickview");
        let variantInventory = document.querySelector(
          '.product-info [data-block-type="inventory"]'
        );

        document
          .querySelectorAll(".pre-order-input")
          .forEach((el) => el.remove());

        setTimeout(() => {
          let btnText;

          if (this.hasAttribute("data-pre-order")) {
            btnText = "Pre-Order";
            if (variantinput) {
              variantinput.insertAdjacentHTML("afterend", preorderinputHTML);
            }
            buttonFullDiv?.classList.add("hidden");
            if (variantInventory) {
              variantInventory.style.setProperty("opacity", "0", "important");
            }
          } else if (this.hasAttribute("data-sold-out")) {
            btnText = "Sold Out";
            buttonFullDiv?.classList.add("hidden");
            if (variantInventory) {
              variantInventory.style.removeProperty("opacity");
            }
          } else {
            btnText = "Add to Cart";
            buttonFullDiv?.classList.remove("hidden");
            if (variantInventory) {
              variantInventory.style.removeProperty("opacity");
            }
          }
          if (addtocartbtn) {
            addtocartbtn.textContent = btnText;
          }
          if (stickycartbtn) {
            stickycartbtn.textContent = btnText;
          }
          if (modalQuickView) {
            let quickviewBtn = modalQuickView.querySelector(
              ".product-ajax-cart-btn"
            );
            if (quickviewBtn) {
              let quickviewSpan = quickviewBtn.querySelector("span");
              if (quickviewSpan) {
                quickviewSpan.textContent = btnText;
              }
              if (this.hasAttribute("data-pre-order")) {
                quickviewBtn.setAttribute("data-preorder", "true");
              } else {
                quickviewBtn.setAttribute("data-preorder", "false");
              }
            }
          }
        }, 10);
      });
    });
// }

  var checkInterval = setInterval(function () {
    var targetElement = document.querySelector(".tdf-ov-atc-fl");
    var preOrderInput = document.querySelector(".pre-order-input"); // single element check

    if (targetElement) {
      if (preOrderInput) {
        targetElement.classList.add("hidden");
      }
      clearInterval(checkInterval); // Stop checking after condition
    }
  }, 200);

  //******* END Pre order code *********//

  //******* Complete The Look Section Append Start *********//
  let interval = setInterval(function () {
    let targetElement = document.querySelector(
      ".product-info__block-item[data-block-type='payment-terms']"
    );
    let elementToMove = document.querySelector(".tdf_bundle.tdf_container");

    if (targetElement && elementToMove) {
      targetElement.insertAdjacentElement("afterend", elementToMove);
      clearInterval(interval);
    }
  }, 100);
  //******* Complete The Look Section Append End *********//
});



// ***********************************************  Java Script Code Start ********************************************* //



// start search cookies

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function appendRecentSearches() {
  var recentSearches = getCookie("recentSearches");
  if (recentSearches) {
    var searchesArray = recentSearches.split(",");
    var spanElement = document.querySelector(".recently_arti");
    spanElement.innerHTML = ""; // Clear previous content
    searchesArray.forEach(function (search) {
      var searchElement = document.createElement("span");
      searchElement.classList.add("search-wrapper");
      var searchInner = document.createElement("span"); // Inner span
      searchInner.textContent = search;
      searchInner.classList.add("search-item");

      searchElement.appendChild(searchInner); // Add inner span to outer span
      spanElement.appendChild(searchElement);

      // Create SVG icon element
      var svgIcon = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      svgIcon.setAttribute("class", "Icon Icon--close");
      svgIcon.setAttribute("role", "presentation");
      svgIcon.setAttribute("viewBox", "0 0 16 14");
      var svgPath = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      svgPath.setAttribute("d", "M15 0L1 14m14 0L1 0");
      svgPath.setAttribute("stroke", "currentColor");
      svgPath.setAttribute("fill", "none");
      svgPath.setAttribute("fill-rule", "evenodd");
      svgIcon.appendChild(svgPath);

      // Append SVG icon directly to the span element
      searchElement.appendChild(svgIcon);

      // Add click event to remove search term
      searchElement.addEventListener("click", function (event) {
        removeSearchTerm(search);
        // appendRecentSearches();
      });

      // Append search element to spanElement
      spanElement.appendChild(searchElement);
    });
  }
}

function removeSearchTerm(term) {
  var recentSearches = getCookie("recentSearches");
  if (recentSearches) {
    var searchesArray = recentSearches.split(",");
    var index = searchesArray.indexOf(term);
    if (index !== -1) {
      searchesArray.splice(index, 1);
      setCookie("recentSearches", searchesArray.join(","), 30); // Store updated searches for 30 days
    }
  }
}

document
  .querySelector(".header-search__input")
  .addEventListener("keypress", function (event) {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent form submission
      var searchValue = this.value.trim();
      $(".btnsearch_all .button").click();

      if (searchValue !== "") {
        var recentSearches = getCookie("recentSearches");
        var searchesArray = recentSearches ? recentSearches.split(",") : [];

        // Add new search term if not already present
        if (!searchesArray.includes(searchValue)) {
          searchesArray.push(searchValue);
        }

        setCookie("recentSearches", searchesArray.join(","), 30); // Store recent searches for 30 days
        appendRecentSearches();
      }
    }
  });

appendRecentSearches();

// End search cookies

//============= klaviyo loggin form close event Code Start ==========

const popupCheckInterval = setInterval(function () {
  const popup = document.querySelector('[aria-label="POPUP Form"]');

  if (popup) {
    document.addEventListener('click', function handler(e) {
      // Check if clicked inside the popup
      if (popup.contains(e.target)) {
        // Do NOT close if clicked on or inside an element with class "needsclick"
        if (e.target.closest('[data-testid="POPUP"]')) {
          return;
        }

        // Otherwise, close the popup
        const closeBtn = popup.querySelector('[aria-label="Close dialog"]');
        if (closeBtn) {
          closeBtn.click();
        }
      }
    });

    clearInterval(popupCheckInterval);
  }
}, 100);

//============= klaviyo loggin form close event Code End =========


// =========== Product page image click open Lightbox Code Start ================

document.addEventListener('click', function (e) {
  if (e.target.matches('.product-gallery__image-list .product-gallery__media img')) {
    const lightboxButton = document.querySelector('open-lightbox-button');
    if (lightboxButton) {
      lightboxButton.click();
    }
  }
});

// =========== Product page image click open Lightbox Code End ================



// =================  IG feed Feature code Start ========================


// var interval = setInterval(function () {
//   const viewer = document.querySelector('.novel-style-embedded-viewer');
//   if (viewer) {
//     const behindThe = document.querySelector('.Behind-the-seams_section');
//     behindThe.style.cssText = 'display: block;';

//     clearInterval(interval);
//   }
// }, 500);

// =================  IG feed Feature code End ========================




// =================  Bundle Product Feature code Start ========================

function updateDiscountsAndVisibility() {
  let checkedCount = $(".bundle-product-section .bundle-product-checkbox:checked").length;
  let totalProducts = $(".bundle-product-section .bundle-product").length;

  // Show/hide price list and buy-buttons
  if (checkedCount === totalProducts) {
    $(".bundle-product-section .price-list.price-list--product").show();
    $(".bundle-product-section .product-info__block-item[data-block-id='buy_buttons']").show();
    $(".bundle-product-section .product-info__block-item[data-block-id='variant_picker']").hide();
    $(".bundle-product-section #bundle-selected-products").hide();
    $(".bundle-product-section .product-price").hide();
    $(".bundle-product-section .bundle-option-group").hide();
    $(".bundle-product-section .bundle-default-option-group").show();
     $(".bundle-product-section .bundle-default-selected").remove(); 
  } else {
    $(".bundle-product-section .price-list.price-list--product").hide();
    $(".bundle-product-section .product-info__block-item[data-block-id='buy_buttons']").hide();
    $(".bundle-product-section .product-info__block-item[data-block-id='variant_picker']").hide();
    $(".bundle-product-section #bundle-selected-products").show();
    $(".bundle-product-section .product-price").show();
    $(".bundle-product-section .bundle-option-group").show();
    $(".bundle-product-section .bundle-default-option-group").hide();
    
  }

  toggleAddButtonState();
}

function toggleAddButtonState() {
  const checkedCount = $(".bundle-product-section .bundle-product-checkbox:checked").length;

  if (checkedCount === 0) {
    $(".bundle-product-section #bundle-selected-products").prop("disabled", true).addClass("disabled");
  } else {
    $(".bundle-product-section #bundle-selected-products").prop("disabled", false).removeClass("disabled");
  }
}

// ✅ Get variant ID from selected options
function getSelectedVariantId(productId, selectedOptions) {
  const productData = window.bundleProductsData[productId];
  if (!productData) return null;

  for (let i = 0; i < productData.variants.length; i++) {
    let variant = productData.variants[i];
    let match = true;
    for (let j = 0; j < selectedOptions.length; j++) {
      if (variant.options[j] !== selectedOptions[j]) {
        match = false;
        break;
      }
    }
    if (match) return variant.id;
  }
  return null;
}

// ✅ Add all selected products based on dropdown variant selection
function addSelectedToCartJS() {
  const selectedItems = [];

  $(".bundle-product-section .bundle-product-checkbox:checked").each(function () {
    const $checkbox = $(this);
    const $product = $checkbox.closest(".bundle-product");
    const productId = $product.data("product-id");
    const variantDropdowns = $product.find(".bundle-variant-option");
    let variantId;

    // If dropdowns exist, collect selected options
    if (variantDropdowns.length > 0) {
      const selectedOptions = [];
      variantDropdowns.each(function () {
        selectedOptions.push($(this).val());
      });
      variantId = getSelectedVariantId(productId, selectedOptions);
    } else {
      // fallback to default variant
      variantId = $checkbox.data("id");
    }
    const properties = {};
      $(".bundle-default-selected").each(function () {
        properties[$(this).attr("name").replace("properties[", "").replace("]", "")] = $(this).val();
      });

    if (variantId) {
      selectedItems.push({
        id: variantId,
        quantity: 1,
        properties: properties 
      });
    }
  });

  if (selectedItems.length === 0) return;

  addNextItem(0, selectedItems);
}

function addNextItem(index, items) {
  if (index >= items.length) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );
    document
      .querySelector('.tdf_cart_icon[aria-controls="cart-drawer"]')
      .click();
    return;
  }

  const item = items[index];

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: jQuery.param(item),
    dataType: "json",
    success: function () {
      addNextItem(index + 1, items);
    },
    error: function (xhr) {
      console.error("Error adding item:", xhr.responseText || xhr);
      addNextItem(index + 1, items);
    }
  });
}

function addDefaultOptionInputs() {
  $(".bundle-product-section .bundle-default-option-group select").each(function () {
    handleDefaultOptionInput($(this));
  });
}

function handleDefaultOptionInput($select) {
  const $group = $select.closest(".bundle-default-option-group");
  const selectedVal = $select.val();
  const labelText = $group.find("label").text().replace(":", "").trim();

  const $bundle = $select.closest(".bundle-product");
  const productId = $bundle.data("product-id");
  const productTitle = $bundle.find("h4").text().trim(); // you can also use a data attr if cleaner

  const inputKey = `${productTitle} - ${labelText}`;
  const inputName = `properties[${inputKey}]`;

  const $form = $(".bundle-product-section .product-info__block-item[data-block-id='buy_buttons'] product-form form");

  let $existingInput = $form.find(`input.bundle-default-selected[data-name="${inputName}"]`);

  if ($existingInput.length > 0) {
    $existingInput.val(selectedVal);
  } else {
    const $input = $('<input>', {
      type: 'hidden',
      class: 'bundle-default-selected',
      'data-name': inputName,
      name: inputName,
      value: selectedVal
    });
    $form.append($input);
  }
}



$(document).ready(function () {
  $(".bundle-product-section .bundle-product-checkbox").prop("checked", true);

  updateDiscountsAndVisibility();
  addDefaultOptionInputs();

  $(".bundle-product-section .bundle-product-checkbox").on("change", function () {
    updateDiscountsAndVisibility();

    if ($(".bundle-product-section .bundle-product-checkbox:checked").length === $(".bundle-product-section .bundle-product").length) {
    addDefaultOptionInputs();
    } else {
      $(".bundle-default-selected").remove();
    }
  });

  $(".bundle-product-section").on("change", ".bundle-variant-option", function () {
    const $select = $(this);
    const $option = $select.find("option:selected");
    const $bundle = $select.closest(".bundle-product");

    const price = $option.data("price");
    const compare = $option.data("compare");

    const $salePrice = $bundle.find(".sale-price");
    const $comparePrice = $bundle.find(".compare-at-price");

    $salePrice.text(price);

     if (compare && compare !== price) {
    $comparePrice.text(compare).show();
  } else {
    $comparePrice.hide();
  }
    
  });
  
  // default variant code 
  $(".bundle-product-section").on("change", ".bundle-default-option-group select", function () {
    handleDefaultOptionInput($(this));
  });

  $(".bundle-product-section #bundle-selected-products").on("click", function () {
    addSelectedToCartJS();
  });
});

// =================  Bundle Product Feature code End ========================


document.addEventListener("DOMContentLoaded", () => {
  const showWidget = () => {
    document.querySelectorAll("access-widget-ui").forEach(widget => {
      try {
        const root = widget.shadowRoot;
        if (!root) return;

        const trigger = root.querySelector('button[part="acsb-trigger"]');
        if (trigger) {
          trigger.style.setProperty("visibility", "visible", "important");
          trigger.querySelector('.icon svg').style.setProperty("max-width", "50%");
          trigger.querySelector('.icon svg').style.setProperty("max-height", "50%");
          console.log("Accessibility widget shown");
        }
      } catch (err) {
        console.warn("Error accessing widget:", err);
      }
    });
  };

  // Run initially
  showWidget();

  // Watch for dynamically added widgets
  const observer = new MutationObserver(showWidget);
  observer.observe(document.body, { childList: true, subtree: true });

  // Re-run periodically as a fallback
  setInterval(showWidget, 2000);
});
